<template>
	<div id="app">
		<top></top>
		<login v-if="islogin" @closepop="showlogon"></login>
		<router-view />
		<bottom></bottom>
	</div>
</template>

<script>
	import Top from './components/public/top.vue';
	import Bottom from './components/public/bottom.vue';
	import Login from './components/login.vue';
	import Bus from '@/store/eventBus.js'
	export default {
		components: {
			Top,
			Bottom,
			Login
		},
		data() {
			return {
				islogin: false
			}
		},
		update(){
			console.log('update',this.$route.path)
		},
		destroyed() {
			// 
		},
		created() {
			Bus.$on("showlogon",data=>{
				console.log('showlogon')
				this.islogin = !this.islogin
			})
			let data={
				lat: 39.928550,
				lng: 116.416370,
			}
			this.$store.commit('initApp');
			this.$store.commit('updateLocation', data);
			// 　var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
			// 　link.type = 'image/x-icon';
			// 　link.rel = 'shortcut icon';
			// 　link.href = './assets/favicon.ico';
			// 　document.getElementsByTagName('head')[0].appendChild(link);
		},
		methods: {
			showlogon() {
				this.islogin = !this.islogin
				Bus.$off('showlogon')
			},
			getloca(){
				
			}
		}
	}
</script>

<style>
	@import './assets/style/commets.css';

	#app {
		background: #F6F6F8;
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;

	}
</style>



// WEBPACK FOOTER //
// src/App.vue